import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import { useAuth, useUpdateInfo } from "../../../core/hooks/useAuth";
import { useUpdateUserPicture } from "../../../core/hooks/useAuth";
import { roleNames } from "../../../core/constants/userConstants";
import { useTranslation } from "react-i18next";
import { Modal, Form, Input, Upload, Button, message } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { useHandleAssign } from "../../../core/hooks/useHandleAssign";

const StudentProfile = () => {
  const { moodleUser } = useAuth();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>(undefined);
  const [avatarItemId, setAvatarItemId] = useState<number | null>(null);
  const [uploading, setUploading] = useState(false);
  const { uploadAssignMutation } = useHandleAssign();
  const updateInfo = useUpdateInfo();
  const updateUserPicture = useUpdateUserPicture(() => {
    setIsModalOpen(false);
    // window.location.reload();
  });

  // Validate file (giới hạn 2MB, chỉ cho phép ảnh)
  const validateAvatarFile = (file: File) => {
    const maxSize = 2 * 1024 * 1024;
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      message.error(t("profile.avatarTypeError") || "Chỉ cho phép file ảnh");
      return false;
    }
    if (file.size > maxSize) {
      message.error(t("profile.avatarSizeError") || "Ảnh không được vượt quá 2MB");
      return false;
    }
    return true;
  };

  // Xử lý upload avatar
  const handleAvatarUpload = async (file: File) => {
    if (!validateAvatarFile(file)) return false;
    const reader = new FileReader();
    reader.onload = e => setAvatarUrl(e.target?.result as string);
    reader.readAsDataURL(file);
    setUploading(true);
    const uploadParams = {
      contextid: moodleUser?.contextid || 1,
      component: "user",
      filearea: "draft",
      itemid: 0,
      filepath: "/",
      filename: file.name,
      file: file,
    };
    try {
      const result: any = await uploadAssignMutation.mutateAsync(uploadParams);
      if (Array.isArray(result) && result[0]?.itemid) {
        const draftitemid = result[0].itemid;
        setAvatarItemId(draftitemid);
        if (result[0].url) setAvatarUrl(result[0].url);
        message.success(t("profile.avatarUploadSuccess"));
      } else {
        message.error(t("profile.avatarUploadError"));
      }
    } catch (error) {
      message.error(t("profile.avatarUploadError"));
    } finally {
      setUploading(false);
    }
    return false;
  };

  useEffect(() => {
    if (updateInfo.isSuccess) {
      setIsModalOpen(false);
      // window.location.reload();
    }
  }, [updateInfo.isSuccess]);

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("profile.myProfile")} />
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5 className="fw-bold">{t("profile.myProfile")}</h5>
              </div>
              <div className="card mb-0">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h6 className="fs-18 ">
                    {t("profile.title")}
                  </h6>
                  <button className="btn btn-primary" onClick={() => {
                    setIsModalOpen(true);
                    form.setFieldsValue({
                      email: moodleUser?.email,
                      phone1: moodleUser?.phone1 || '',
                      phone2: moodleUser?.phone2 || '',
                    });
                    setAvatarUrl(undefined);
                  }}>{t("profile.editProfile")}</button>
                </div>
                <div className="card-body">
                  {moodleUser ? (
                    <>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.fullName")}</h6>
                            <span>{moodleUser?.fullname}</span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.position")}</h6>
                            {moodleUser?.role ? (
                              <span>
                                {t(roleNames[moodleUser?.role?.roleid])}
                              </span>
                            ) : (
                              <span>{t("profile.notAssigned")}</span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.userName")}</h6>
                            <span>{moodleUser?.username}</span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.email")}</h6>
                            <span>{moodleUser?.email}</span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.phone")}</h6>
                            {moodleUser?.phone1 || moodleUser?.phone2 ? (
                              <span>
                                {moodleUser?.phone1} - {moodleUser?.phone2}
                              </span>
                            ) : (
                              <span>{t("profile.notHavePhone")}</span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.city")}</h6>
                            <span>{moodleUser?.city}</span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <h6>{t("profile.country")}</h6>
                            <span>{moodleUser?.country}</span>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    t("profile.guest")
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal chỉnh sửa thông tin */}
      <Modal
        title={t("profile.editProfile")}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={async (values) => {
            if (avatarItemId) {
              // Cập nhật avatar trước, sau đó cập nhật info
              updateUserPicture.mutate({
                userid: moodleUser?.id,
                draftitemid: avatarItemId,
              }, {
                onSuccess: () => {
                  updateInfo.mutate({
                    users: [
                      {
                        id: moodleUser?.id,
                        email: values.email,
                        phone1: values.phone1,
                        phone2: values.phone2,
                      }
                    ]
                  });
                }
              });
            } else {
              updateInfo.mutate({
                users: [
                  {
                    id: moodleUser?.id,
                    email: values.email,
                    phone1: values.phone1,
                    phone2: values.phone2,
                  }
                ]
              });
            }
          }}
          
        >
          <Form.Item
            label={t('profile.email')}
            name="email"
            rules={[
              { required: true, message: t('profile.emailRequired') },
              { type: 'email', message: t('profile.emailInvalid') }
            ]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            label={t('profile.phone1')}
            name="phone1"
            rules={[
              {
                validator: (_, value) => {
                  const phone2 = form.getFieldValue('phone2');
                  if (!value && !phone2) {
                    return Promise.reject(new Error(t('profile.phoneRequired')));
                  }
                  if (value && !/^[0-9]{10}$/.test(value)) {
                    return Promise.reject(new Error(t('profile.phoneInvalid')));
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <Input
              onChange={() => {
                setTimeout(() => form.validateFields(['phone2']), 0);
              }}
            />
          </Form.Item>
          <Form.Item
            label={t('profile.phone2')}
            name="phone2"
            rules={[
              {
                validator: (_, value) => {
                  const phone1 = form.getFieldValue('phone1');
                  if (!value && !phone1) {
                    return Promise.reject(new Error(t('profile.phoneRequired')));
                  }
                  if (value && !/^[0-9]{10}$/.test(value)) {
                    return Promise.reject(new Error(t('profile.phoneInvalid')));
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <Input
              onChange={() => {
                setTimeout(() => form.validateFields(['phone1']), 0);
              }}
            />
          </Form.Item>
          <Form.Item label={t('profile.avatar')}>
            <Upload name="avatar" listType="picture" showUploadList={false} beforeUpload={handleAvatarUpload} accept="image/png,image/jpeg,image/jpg,image/webp">
              <Button icon={<UploadOutlined />} loading={uploading}>{t('profile.uploadAvatar')}</Button>
            </Upload>
            {(avatarUrl || moodleUser?.avatar) && (
              <img src={avatarUrl || moodleUser?.avatar} alt="avatar" style={{ width: 60, height: 60, marginTop: 8, borderRadius: '50%', marginLeft: 10, marginBottom: 10 }} />
            )}
            <div style={{ fontSize: 12, marginTop: 4, color: '#888' }}>
              {t('profile.avatarGuideline') || "Chỉ cho phép file PNG, JPG, JPEG, WebP. Dung lượng tối đa 2MB."}
            </div>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={updateInfo.isPending} block>
              {t('profile.save')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default StudentProfile;
